export function getDocuments() {
  return {
    type: 'GET_DOCUMENTS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getEdocs',
            mock: false
          },
        },
        commit: {
          type: 'GET_DOCUMENTS_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENTS_ROLLBACK',
        }
      },
    },
  }
}

export function clearDocuments() {
  return {
    type: 'CLEAR_DOCUMENTS',
  }
}

export function setDocument(document) {
  return {
    type: 'SET_DOCUMENT',
    payload: { document }
  }
}

export function clearDocument() {
  return {
    type: 'CLEAR_DOCUMENT',
  }
}

export function clearDocumentFetchTimestamp() {
  return {
    type: 'CLEAR_DOCUMENT_FETCH_TIMESTAMP',
  }
}

export function setPolicy(policy) {
  return {
    type: 'SET_POLICY',
    payload: { policy }
  }
}

export function clearPolicy() {
  return {
    type: 'CLEAR_POLICY',
  }
}

export function getPoliciesDetails() {
  return {
    type: 'GET_POLICIES_DETAILS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPoliciesDetails',
            mock: false
          },
        },
        commit: {
          type: 'GET_POLICIES_DETAILS_COMMIT',
        },
        rollback: {
          type: 'GET_POLICIES_DETAILS_ROLLBACK',
        }
      },
    },
  }
}

export function getPolicyDetails(id) {
  return {
    type: 'GET_POLICY_DETAILS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPolicyDetails',
            mock: false,
            query: [{
              name: 'id',
              value: id,
            }],
          },
        },
        commit: {
          type: 'GET_POLICY_DETAILS_COMMIT',
        },
        rollback: {
          type: 'GET_POLICY_DETAILS_ROLLBACK',
        }
      },
    },
  }
}

export function setAddedToWallet(documentId) {
  return {
    type: 'SET_ADDED_TO_WALLET',
    payload: {
      documentId,
    }
  }
}

export function createSlip(data) {
  return {
    type: 'DOCUMENTS_SLIP_CREATE',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/documents/slip'
          },
        },
        commit: {
          type: 'DOCUMENTS_SLIP_CREATE_COMMIT',
        },
        rollback: {
          type: 'DOCUMENTS_SLIP_CREATE_ROLLBACK',
        },
      },
    },
  }
}
